import { render, staticRenderFns } from "./subActivate.vue?vue&type=template&id=794f189c"
import script from "./subActivate.vue?vue&type=script&lang=js"
export * from "./subActivate.vue?vue&type=script&lang=js"
import style0 from "./subActivate.vue?vue&type=style&index=0&id=794f189c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports